import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { getStoredData, get_auth_key } from '../../../util';
import { get } from '../../../services/apiController';

const OrderPreview = ({ openModal, closeModal, data, images }) => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const [location, setLocation] = useState(null);
  const branchId = storedData.role === 'cake-manager' ? storedData?.locationId[0] : null;
  useEffect(() => {
    if (branchId && storedData.role === 'cake-manager') {
      get('/branches/?id=' + branchId).then((res) => {
        if (res.data.rows.length) {
          setLocation(res.data.rows[0]);
        }
      });
    }
  }, [branchId, storedData?.role]);

  const imagesPreviews = images && images.length > 0 && Array.from(images);
  return (
    <Modal size="lg" show={openModal} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>{location ? `Order Preview (${location?.name} - ${location?.number})` : 'Order Preview'}</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
      </Modal.Header>
      <Modal.Body style={{ fontFamily: 'auto' }}>
        <Table bordered striped responsive className="mb-3">
          <tbody>
            <tr>
              <th>Product Name</th>
              <td>{data?.productName}</td>
              <th>Name on the Cake</th>
              <td>{data?.nameOnCake}</td>
            </tr>
            <tr>
              <th>Special Instruction.</th>
              <td>{data?.instruction}</td>
              <th>Customer Name</th>
              <td>{data?.customerName}</td>
            </tr>
            <tr>
              <th>Customer Phone</th>
              <td>{data?.customerPhone}</td>
              <th>Customer Email</th>
              <td>{data?.customerEmail}</td>
            </tr>
            <tr>
              <th>Purpose</th>
              <td>{data?.purpose}</td>
              <th>Delivery Date</th>
              <td>{data?.deliveryDate}</td>
            </tr>
            <tr>
              <th>Advance Amount</th>
              <td>{data?.advanceAmount}</td>
              <th>Extra Charge</th>
              <td>{data?.extraCharge}</td>
            </tr>
          </tbody>
        </Table>
        <p>Uploaded Images: </p>
        {imagesPreviews &&
          imagesPreviews.length > 0 &&
          imagesPreviews.map((image, index) => {
            return (
              <img style={{ padding: '10px' }} key={index} width="134px" height="134px" src={URL.createObjectURL(image)} alt={index} />
            );
          })}
      </Modal.Body>
    </Modal>
  );
};

export default OrderPreview;
